import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  AccountCircleOutlined,
  DonutLargeOutlined,
  EmailOutlined,
  HttpOutlined,
  LocalPhoneOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetAccountDetailQuery } from "store/services/accountApi";

import { useAuth } from "hooks/useAuth";

const AccountInfoScreen = () => {
  const { viewEntity } = useAuth();

  const accountId = viewEntity?.entity?.account?._id;

  const breadcrumbs = [
    {
      title: "Account Info",
    },
  ];

  // RTK Query
  const {
    data: accountDetail,
    isLoading: loadingAccountDetail,
    error,
  } = useGetAccountDetailQuery(accountId);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingAccountDetail}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingAccountDetail ? (
          <Box padding={3}>
            <Typography variant="h6">{accountDetail?.name}</Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountCircleOutlined color="primary" />}
                  title="Display Name"
                  subtitle={accountDetail?.displayName}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HttpOutlined color="primary" />}
                  title="Domain"
                  subtitle={accountDetail?.domain}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <EmailOutlined color="primary" />}
                  title="Assistance Email"
                  subtitle={accountDetail?.email}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalPhoneOutlined color="primary" />}
                  title="Assistance Phone"
                  subtitle={accountDetail?.contactNumber}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DonutLargeOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={accountDetail?.status === "Active"} />
                </InformationTile>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AccountInfoScreen;
